import { render } from "./PromoProducts.vue?vue&type=template&id=d3127964&scoped=true"
import script from "./PromoProducts.vue?vue&type=script&lang=js"
export * from "./PromoProducts.vue?vue&type=script&lang=js"

import "./PromoProducts.vue?vue&type=style&index=0&id=d3127964&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3127964"]])

export default __exports__